import styled from 'styled-components';
export const DatepickerWrapper = styled.div.withConfig({
  displayName: "Style__DatepickerWrapper",
  componentId: "sc-1i70i7o-0"
})(["position:relative;"]);